import React from "react";

import { useTranslation } from "utils";

import { Button, Flex, Icon, Typography } from "components";

type SuccessStepProps = {
  year: number;
  fieldsMatched: number;
  inserted: number;
  onAddMissingData: () => void;
  onImportMore: () => void;
};

export const SuccessStep = ({ year, fieldsMatched, inserted, onAddMissingData, onImportMore }: SuccessStepProps) => {
  const { t } = useTranslation("docScans");

  return (
    <div className="doc-scan-content">
      <Flex vertical align="center" gap="2rem" style={{ width: "100%" }}>
        <div className="doc-scan-success-circles">
          <div className="doc-scan-success-circles__mid">
            <div className="doc-scan-success-circles__inner">
              <Icon iconName="tabler/check" size="l" color="white" />
            </div>
          </div>
        </div>

        <Flex vertical align="center" gap="0.5rem" className="text-center">
          <Typography variant="h2">{t("success.title", { year })}</Typography>
          <Typography variant="paragraph-m" color="grey-600">
            {t("success.subtext", { year })}
          </Typography>
        </Flex>

        <div className="doc-scan-success-stats">
          <div className="doc-scan-success-stat">
            <Typography variant="h2">{fieldsMatched}</Typography>
            <Typography variant="paragraph-s" color="grey-600">
              {t("success.stats.fieldsMatched")}
            </Typography>
          </div>
          <div className="doc-scan-success-stat highlighted">
            <Typography variant="h2">{inserted}</Typography>
            <Typography variant="paragraph-s" color="grey-600">
              {t("success.stats.importedCrops")}
            </Typography>
          </div>
        </div>

        <div className="doc-scan-success-actions">
          <Button type="primary" onClick={onAddMissingData} block>
            {t("success.actions.addMissingData")}
            <Icon iconName="tabler/arrow-right" size="s" color="white" />
          </Button>
          <Button type="secondary" onClick={onImportMore} block>
            <Icon iconName="tabler/download" size="s" />
            {t("success.actions.importMore")}
          </Button>
        </div>
      </Flex>
    </div>
  );
};
